// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"pj_a bgu_i bgu_j bgu_q bgu_un bgu_wf bgu_en"};